/*
 * @Description: 全局过滤器
 * @Autor: WangYuan
 * @Date: 2021-09-15 19:48:43
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-09-16 11:47:12
 */
import Vue from 'vue'
import { formatDate } from './date'

const filters = {
    // 价格显示 分 -> 元  （带两位小数）
    moneyDec(target) {
        return (target / 100).toFixed(2)
    },

    // 价格显示 分 -> 元
    money(target) {
        return target / 100
    },

    // 日期格式化
    formatDate(date, fmt = 'YYYY-MM-DD HH:mm:ss') {
        if (!date) return ''
        // 直接用 new Date 处理，兼容 ISO 字符串和时间戳
        const d = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date
        return formatDate(d, fmt)
    }
}

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})